/**
 * DevExtreme (esm/__internal/core/r1/runtime/inferno/effect_host.js)
 * Version: 25.1.4
 * Build date: Tue Aug 05 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export const InfernoEffectHost = {
    lockCount: 0,
    lock() {
        this.lockCount++
    },
    callbacks: [],
    callEffects() {
        this.lockCount--;
        if (this.lockCount < 0) {
            throw new Error("Unexpected Effect Call")
        }
        if (0 === this.lockCount) {
            const effects = this.callbacks;
            this.callbacks = [];
            effects.forEach((callback => callback()))
        }
    }
};
